/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Whitelabeling configuration.
 * @export
 * @interface GetServiceprovider200ResponseWhitelabel
 */
export interface GetServiceprovider200ResponseWhitelabel {
    /**
     * Contact email address shown to clients.
     */
    email: string;
    /**
     * Contact phone number shown to clients.
     */
    phone: string;
    /**
     * Whether a custom logo has been uploaded.
     */
    hasLogo: boolean;
    /**
     * Whether whitelabeling is active for this serviceprovider.
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the GetServiceprovider200ResponseWhitelabel interface.
 */
export function instanceOfGetServiceprovider200ResponseWhitelabel(value: object): value is GetServiceprovider200ResponseWhitelabel {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('hasLogo' in value) || value['hasLogo'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetServiceprovider200ResponseWhitelabelFromJSON(json: any): GetServiceprovider200ResponseWhitelabel {
    return GetServiceprovider200ResponseWhitelabelFromJSONTyped(json, false);
}

export function GetServiceprovider200ResponseWhitelabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceprovider200ResponseWhitelabel {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'phone': json['phone'],
        'hasLogo': json['hasLogo'],
        'isActive': json['isActive'],
    };
}

export function GetServiceprovider200ResponseWhitelabelToJSON(json: any): GetServiceprovider200ResponseWhitelabel {
    return GetServiceprovider200ResponseWhitelabelToJSONTyped(json, false);
}

export function GetServiceprovider200ResponseWhitelabelToJSONTyped(value?: GetServiceprovider200ResponseWhitelabel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phone': value['phone'],
        'hasLogo': value['hasLogo'],
        'isActive': value['isActive'],
    };
}

